import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DayView} from '../../core/DayView';
import {HIUser} from '../../core/HIUser';
import {Booking} from '../../core/Booking';
import {DataService} from '../../core/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'calander-view',
  templateUrl: './calander-view.component.html',
  styleUrls: ['./calander-view.component.css']
})
export class CalanderViewComponent implements OnInit  {
    @Input()
    set dailyViews(dailyViews: DayView[]) {
        this.dayViews = dailyViews;
    }
  constructor(private dataService: DataService, private router: Router) {}
    view = 'month';
    dayViews: DayView[] = [];
    selectedDay: boolean;
    selectedBooking: boolean;

    viewDate: Date = new Date();


    @Output() reloadDayViewDates: EventEmitter<Date> = new EventEmitter();
    daySelected: DayView;
    selectedBookingUser: HIUser;
    bookingSelected: Booking;

    currentSelectedDayView: number;
    ngOnInit() {
        console.log('Calander view component');
    }
    reloadDayViews($event: Date) {
        this.reloadDayViewDates.next($event);
    }
    incrementSelectDay() {
        this.selectDay(this.currentSelectedDayView + 1);
    }
    decrementSelectDay() {
        this.selectDay(this.currentSelectedDayView - 1);
    }
    selectDay(dayView: number) {
        this.currentSelectedDayView = dayView;
        this.selectedDay = true;
        this.daySelected = this.dayViews[dayView];
    }

    selectBooking($event: any) {
        this.selectedDay = false;
        this.selectedBookingUser = $event.user;
        this.bookingSelected = $event.booking;
        this.selectedBooking = true;
    }
    actionDeleteBooking() {
        this.dataService.callDelete('bookings/' + this.bookingSelected.sid).subscribe(
            () => {
              this.router.navigate(['/admin']);
            },
            error => {
              console.log(error);
            }
        );
      }

    updateBooking($event: Booking) {
        this.selectedBooking = false;
        if ($event == null) {

        } else if ($event.deleted) {
            this.dataService.callDelete('bookings/' + $event.sid).subscribe();
        } else if ($event.sid) {
            this.dataService.callPut('bookings', JSON.stringify($event)).subscribe(
                () => {
                    console.log('done');
                },
                error => {
                    console.log(error);
                }
            );
        }
        this.selectedBooking = null;
    }

    formatDate(): string {
        const date = new Date(this.daySelected.calanderDate);
        return date.toLocaleString('en', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      }
      navigateToEdit(bookingSid: number) {
        this.router.navigate(['admin/bookStep', {bookingSid: bookingSid}]);
      }
}
